import React from 'react';
import { SidebarTrigger } from '../ui/sidebar';
import { GlobalSearchTrigger } from '../search/GlobalSearchTrigger';

export const MobileHeader: React.FC = () => {
  return (
    <header className="fixed top-0 z-50 flex h-14 w-full items-center justify-between border-b border-sidebar-border bg-background px-4 md:hidden">
      <SidebarTrigger className="h-7 w-7" />
      <GlobalSearchTrigger
        variant="icon"
        size="icon"
        className="h-7 w-7"
        showKeyboardShortcut={false}
      />
    </header>
  );
};